export default class GenericError extends Error {
  constructor(errorCode, message, details = {}) {
    super(message);

    this.name = 'GenericError';
    this.errorCode = errorCode; // Machine comparable value
    this.message = message; // Human readable reason (IE. Message)
    this.details = details; // Any other details
  }
}
